import { useEffect, useRef } from 'react';
import { useUserContext } from '@/shared/features/user-context/presentation/hooks/useUserContext';
import { useFeatureFlags } from '@/features/feature-flags/presentation/hooks/useFeatureFlags';
import { useLazyGetUserContextQuery } from '@/shared/features/user-context/infra/adapters/userContextApiSlice';
import { getSoftLoginService } from '../../config/softLogin.build';

/** Guest + !isSoftLoggedIn + isSoftLoginEnabled → Shopflo script → add-sl once, then refetches user context. */
export function useSoftLogin(): void {
  const { userContext, isLoading: isUserLoading } = useUserContext();
  const { flags, isLoading: isFlagsLoading } = useFeatureFlags();
  const [refetchUserContext] = useLazyGetUserContextQuery();
  const startedRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined' || isUserLoading || isFlagsLoading || startedRef.current) {
      return;
    }

    if (!flags.isSoftLoginEnabled) {
      return;
    }

    const isLoggedIn = userContext?.isLoggedIn ?? false;
    const isSoftLoggedIn = userContext?.isSoftLoggedIn ?? false;

    if (isLoggedIn || isSoftLoggedIn) {
      return;
    }

    startedRef.current = true;
    getSoftLoginService().start(() => {
      void refetchUserContext(undefined, false);
    });
  }, [isUserLoading, isFlagsLoading, flags.isSoftLoginEnabled, userContext?.isLoggedIn, userContext?.isSoftLoggedIn, refetchUserContext]);
}
